import styled from "styled-components";
import { SubgridColumn } from "../store/types";
import { Color, Flex, Grid, Text } from "src/elements";
import { SubgridCell } from "./SubgridCell";
import { reduceSubgridTableColumnsToBodyColumns } from "../store/utils";
import { lightenDarkenColor } from "src/utils";
import React from "react";

const Footer = styled(Grid)<{ subheadersCount: number }>`
  grid-template-columns: subgrid;
  grid-column: ${({ subheadersCount }) => subheadersCount > 0 && `span ${subheadersCount}`};
`;

const FooterWrapper = <T,>({
  column,
  isLeftBorder,
  children,
}: {
  column: SubgridColumn<T>;
  isLeftBorder: boolean;
  children: React.ReactNode;
}) =>
  column.headerWithoutStyle ? (
    <React.Fragment>{children}</React.Fragment>
  ) : (
    <SubgridCell
      background={Color.primaryActive}
      align="center"
      borderColor={lightenDarkenColor(Color.primaryActive, -15)}
      leftBorder={isLeftBorder}
    >
      {children}
    </SubgridCell>
  );

interface Props<T> {
  column: SubgridColumn<T>;
  isLeftBorder: boolean;
}

export const SubgridFooter = <T,>({ column, isLeftBorder }: Props<T>) => {
  const subHeadersCount = column.subColumns
    ? reduceSubgridTableColumnsToBodyColumns(column.subColumns).length
    : 0;

  return (
    <Footer subheadersCount={subHeadersCount}>
      <FooterWrapper column={column} isLeftBorder={isLeftBorder}>
        <Flex gap="3px" align="center">
          <Text variant="small1" color={Color.white}>
            {column.footer}
          </Text>
        </Flex>
      </FooterWrapper>
    </Footer>
  );
};
